export default __webpack_public_path__ + "static/media/Scarclaw Leggings.e46e89ac.jpg";